import {CommonModule} from '@angular/common';
import {Component, computed, input, Signal, ChangeDetectionStrategy} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SeFeLinkModule} from 'se-fe-link';
import {getTableRowImages, getTableRowName, ProductTableRow} from '../../product-table/product-table-row';

type Images =
  | {
      src: string;
      alt: string;
      width?: string | undefined;
      height?: string | undefined;
    }[]
  | undefined;

@Component({
  selector: 'product-name-cell',
  imports: [CommonModule, RouterModule, SeFeLinkModule],
  templateUrl: './product-name-cell.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-name-cell.component.scss',
})
export class ProductNameCellComponent {
  product = input.required<ProductTableRow>();
  link = input<string | undefined>();
  target = input<'_blank' | '_self'>('_self');

  name = computed(() => getTableRowName(this.product()));
  images: Signal<Images> = computed(() => getTableRowImages(this.product()));

  isValidImage(images: Images): boolean {
    const imagesExist = images && images.length > 0;
    if (!imagesExist) {
      return false;
    }

    const src = images[0]?.src;

    try {
      new URL(src);
    } catch (__error) {
      return false;
    }

    const imageRegex = /\.(jpe?g|png)$/i;
    return imageRegex.test(src);
  }
}
